module.exports = __webpack_public_path__ + "img/newPaintingPav9m.fa598db2.png";